import React from 'react';
import {render} from 'react-dom';
import {Route, Router, Switch} from 'react-router-dom';

import firebase from '@firebase/app';
import '@firebase/firestore';
import '@firebase/messaging';
import {FirestoreProvider} from 'react-firestore';

import RankingScreen from './containers/RankingScreen';
import FavoritosScreen from './containers/FavoritosScreen';
import FavoritoSearchScreen from './containers/FavoritoSearchScreen';
import EventoListScreen from './containers/EventoListScreen';
import EventoDetailScreen from './containers/EventoDetailScreen';
import CompeticionScreen from './containers/CompeticionScreen';
import ResultadoScreen from './containers/ResultadoScreen';
import CONFIG from './config';

import './scss/Main.css';
import Notificaciones from './components/Notificaciones';
import * as serviceWorker from './registerServiceWorker';
import LocationListScreen from './containers/LocationListScreen';
import LocationDetailScreen from './containers/LocationDetailScreen';
import CompeticionGps from './containers/CompeticionGps';

const createHistory = require('history').createBrowserHistory

const firebaseConfig = {
  apiKey: CONFIG.FIREBASE_APIKEY,
  projectId: CONFIG.FIREBASE_PROJECTID,
  messagingSenderId: CONFIG.FCM_SENDER_ID,
  appId: CONFIG.FIREBASE_APPID
}
firebase.initializeApp(firebaseConfig)
// const firestore = firebase.firestore()
// firestore.settings({ timestampsInSnapshots: true })

// ...

const FcmSource = {
  listener: () => {},
  subscribe: (fn) => {
    FcmSource.listener = fn
  }
}

window.FCM_TOKEN = null
try {
  // Notifications supported! Yay!
  const messaging = firebase.messaging()
  messaging.usePublicVapidKey(CONFIG.FCM_PUBLIC_KEY)

  messaging
    .requestPermission()
    .then(() => {
      console.log('Have Permission')
      return messaging.getToken()
    })
    .then(token => {
      window.FCM_TOKEN = token
      console.log('FCM Token:', token)
      // you probably want to send your new found FCM token to the
      // application server so that they can send any push
      // notification to you.
    })
    .catch(error => {
      if (error.code === 'messaging/permission-blocked') {
        console.log('Please Unblock Notification Request Manually')
      } else {
        console.log('Error Occurred', error)
      }
    })

  // @todo: si cambia el token
  messaging.onTokenRefresh(() => {})

  // ...
  // Mensajes recibidos cuando la app está en primer plano.
  messaging.onMessage((payload) => {
    // console.log('onMessage', payload)
    return FcmSource.listener(payload)
  })
} catch (e) {
  console.trace(e)
}

// ...
const history = createHistory()

// https://stackoverflow.com/questions/42710456/uncaught-referenceerror-ga-is-not-defined-with-garequire-ec
window['GoogleAnalyticsObject'] = 'ga'
window['ga'] = window['ga'] || function () {
  (window['ga'].q = window['ga'].q || []).push(arguments)
}

history.listen(function (location) {
  // console.info(location.pathname + location.search)
  // console.info(window.ga)
  if (typeof window.ga === 'function') {
    window.ga('set', 'page', location.pathname + location.search)
    window.ga('send', 'pageview')
    // console.info(location.pathname + location.search)
  }
})

render(
  <FirestoreProvider firebase={firebase}>
    <Notificaciones fcm={FcmSource} />
    <Router history={history}>
      <Switch>
        <Route exact path='/' component={EventoListScreen} />
        <Route exact path='/:eventoId' component={EventoDetailScreen} />
        <Route exact path='/:eventoId/locations' component={LocationListScreen} />
        <Route exact path='/:eventoId/location/:locationId' component={LocationDetailScreen} />
        <Route exact path='/competicion/:competicionId' component={CompeticionScreen} />
        <Route exact path='/competicion/:competicionId/favoritos' component={FavoritosScreen} />
        <Route exact path='/competicion/:competicionId/gps' component={CompeticionGps} />
        <Route exact path='/competicion/:competicionId/ranking' component={RankingScreen} />
        <Route exact path='/competicion/:competicionId/ranking/:rankingId' component={RankingScreen} />
        { /* <Route exact path='/competicion/:competicionId/favoritos/control/:controlId' component={FavoritosScreen} /> */ }
        <Route exact path='/competicion/:competicionId/buscar' component={FavoritoSearchScreen} />
        <Route exact path='/competicion/:competicionId/dorsal/:dorsal' component={ResultadoScreen} />
        <Route exact path='/competicion/:competicionId/control/:controlId' component={CompeticionScreen} />
      </Switch>
    </Router>
  </FirestoreProvider>,
  document.getElementById('root')
)

serviceWorker.default()



// WEBPACK FOOTER //
// ./src/index.js